var map = {
	"./blog/0/first.png": 4106,
	"./blog/0/next.png": 8867,
	"./blog/0/second.png": 1856,
	"./blog/0/slider/01.png": 9734,
	"./blog/0/slider/02.png": 1301,
	"./blog/0/slider/03.png": 5399,
	"./blog/0/slider/04.png": 2251,
	"./blog/1/first.png": 1299,
	"./blog/1/next.png": 2598,
	"./blog/1/second.png": 565,
	"./blog/1/slider/01.png": 638,
	"./blog/1/slider/02.png": 6954,
	"./blog/1/slider/03.png": 2504,
	"./blog/1/slider/04.png": 162,
	"./blog/2/first.png": 1683,
	"./blog/2/next.png": 9822,
	"./blog/2/second.png": 8125,
	"./blog/2/slider/01.png": 7393,
	"./blog/2/slider/02.png": 8795,
	"./blog/2/slider/03.png": 7513,
	"./blog/2/slider/04.png": 2318,
	"./projects/0/atlas-m.png": 1614,
	"./projects/0/atlas.png": 624,
	"./projects/0/first-m.png": 4214,
	"./projects/0/first.png": 9497,
	"./projects/0/next-m.png": 7940,
	"./projects/0/next.png": 7802,
	"./projects/0/slider/01.png": 5257,
	"./projects/0/slider/02.png": 2725,
	"./projects/0/slider/03.png": 439,
	"./projects/0/slider/04.png": 7292,
	"./projects/1/first-m.png": 2440,
	"./projects/1/first.png": 7834,
	"./projects/1/next.png": 9423,
	"./projects/1/playboy-m.png": 8161,
	"./projects/1/playboy.png": 8677,
	"./projects/1/slider/01.png": 8602,
	"./projects/1/slider/02.png": 4820,
	"./projects/1/slider/03.png": 5865,
	"./projects/1/slider/04.png": 2160,
	"./projects/2/first-m.png": 8064,
	"./projects/2/first.png": 2409,
	"./projects/2/next.png": 5589,
	"./projects/2/slider/01.png": 1699,
	"./projects/2/slider/02.png": 2537,
	"./projects/2/slider/03.png": 3959,
	"./projects/2/slider/04.png": 2222,
	"./projects/2/the_world_news-m.png": 8846,
	"./projects/2/the_world_news.png": 8083,
	"./projects/3/first-m.png": 5529,
	"./projects/3/first.png": 7910,
	"./projects/3/music_awards-m.png": 463,
	"./projects/3/music_awards.png": 2818,
	"./projects/3/next.png": 8306,
	"./projects/3/slider/01.png": 1267,
	"./projects/3/slider/02.png": 2610,
	"./projects/3/slider/03.png": 7237,
	"./projects/3/slider/04.png": 3174,
	"./projects/4/first-m.png": 5069,
	"./projects/4/first.png": 2471,
	"./projects/4/next.png": 6130,
	"./projects/4/slider/01.png": 1152,
	"./projects/4/slider/02.png": 9500,
	"./projects/4/slider/03.png": 9264,
	"./projects/4/slider/04.png": 1257,
	"./projects/4/unn-m.png": 1307,
	"./projects/4/unn.png": 789,
	"./projects/5/first-m.png": 4415,
	"./projects/5/first.png": 4848,
	"./projects/5/next.png": 7298,
	"./projects/5/slider/01.png": 2479,
	"./projects/5/slider/02.png": 8327,
	"./projects/5/slider/03.png": 6216,
	"./projects/5/slider/04.png": 6168,
	"./projects/5/sluhay-m.png": 7774,
	"./projects/5/sluhay.png": 2201,
	"./slide_3/atlas.png": 6242,
	"./slide_3/digital.png": 7021,
	"./slide_3/jn.png": 3997,
	"./slide_3/m1.png": 784,
	"./slide_3/mgu.png": 1050,
	"./slide_3/parimatch.png": 4582,
	"./slide_3/playboy.png": 7958,
	"./slide_3/sluhay.png": 484,
	"./slide_3/sw.png": 8495,
	"./slide_3/tk.png": 9956,
	"./slide_3/twn.png": 3879,
	"./slide_3/unn.png": 4597,
	"./slide_5/max_photo-m.png": 8628,
	"./slide_5/max_photo.png": 8639,
	"./slide_6/atlas.png": 4500,
	"./slide_6/bitcoin.png": 4421,
	"./slide_6/max.png": 4211,
	"./slide_6/sluhay.png": 4369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;